import React from "react";
import { CircularProgress, Backdrop } from "@material-ui/core";

interface Props {
  open: boolean;
}

const LoadingOverlay: React.FC<Props> = ({ open }) => {
  return (
    <Backdrop open={open} style={{ zIndex: 1500, color: "#fff" }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoadingOverlay;
